var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gql } from '@apollo/client';
import { useVeridApi } from 'ui-lib';
var DEBUG = false;
export var TEAM_MEMBER_FIELDS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment TeamMemberFragment on TeamMember {\n    id\n    createdAt\n    updatedAt\n    status\n    role\n    title\n    firstName\n    middleName\n    lastName\n    orgName\n  }\n"], ["\n  fragment TeamMemberFragment on TeamMember {\n    id\n    createdAt\n    updatedAt\n    status\n    role\n    title\n    firstName\n    middleName\n    lastName\n    orgName\n  }\n"])));
export function useTeamMemberService() {
    var api = useVeridApi();
    var teamMembersQuery = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    query teamMembers($firstName: String, $lastName: String, $teamId: String!, $orderBy: TeamMemberOrder, $first: Int, $after: String) {\n      teamMembers(query: { firstName: $firstName, lastName: $lastName, teamId: $teamId }, orderBy: $orderBy, first: $first, after: $after) {\n        edges {\n          cursor\n          node {\n            ...TeamMemberFragment\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n          hasPreviousPage\n          startCursor\n        }\n        totalCount\n      }\n    }\n  "], ["\n    ", "\n    query teamMembers($firstName: String, $lastName: String, $teamId: String!, $orderBy: TeamMemberOrder, $first: Int, $after: String) {\n      teamMembers(query: { firstName: $firstName, lastName: $lastName, teamId: $teamId }, orderBy: $orderBy, first: $first, after: $after) {\n        edges {\n          cursor\n          node {\n            ...TeamMemberFragment\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n          hasPreviousPage\n          startCursor\n        }\n        totalCount\n      }\n    }\n  "])), TEAM_MEMBER_FIELDS);
    return {
        useTeamMemberQuery: function (options) {
            function fct() {
                return api.useQuery(teamMembersQuery, options);
            }
            return fct;
        },
        teamMember: function (id) {
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, api.query({
                            query: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          query teamMember($id: String!) {\n            teamMember(id: $id) {\n              status\n              role\n            }\n          }\n        "], ["\n          query teamMember($id: String!) {\n            teamMember(id: $id) {\n              status\n              role\n            }\n          }\n        "]))),
                            variables: { id: id },
                            fetchPolicy: 'network-only',
                        })];
                });
            });
        },
        teamMemberCreate: function (team) {
            return __awaiter(this, void 0, Promise, function () {
                var retVal;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, api.mutate({
                                mutation: gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          mutation teamMemberCreate($data: TeamMemberCreateInput!) {\n            teamMemberCreate(data: $data) {\n              id\n            }\n          }\n        "], ["\n          mutation teamMemberCreate($data: TeamMemberCreateInput!) {\n            teamMemberCreate(data: $data) {\n              id\n            }\n          }\n        "]))),
                                variables: { data: team },
                                refetchQueries: ['teamMembers'],
                            })];
                        case 1:
                            retVal = _a.sent();
                            return [4 /*yield*/, api.refreshMe()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/, retVal];
                    }
                });
            });
        },
        teamMemberUpdate: function (teamMemberId, teamMember) {
            return __awaiter(this, void 0, Promise, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, api.mutate({
                            mutation: gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          mutation teamMemberUpdate($id: String!, $data: TeamMemberUpdateInput!) {\n            teamMemberUpdate(id: $id, data: $data) {\n              id\n            }\n          }\n        "], ["\n          mutation teamMemberUpdate($id: String!, $data: TeamMemberUpdateInput!) {\n            teamMemberUpdate(id: $id, data: $data) {\n              id\n            }\n          }\n        "]))),
                            variables: { data: teamMember, id: teamMemberId },
                            refetchQueries: ['teamMembers'],
                        })];
                });
            });
        },
    };
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
